export default {
    GetComments: 'api/public/comments',
    AddComment: 'api/public/comments',
    DeleteComment: 'api/public/comments',
  };
  